var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"order-section"},_vm._l((_vm.items),function(order,i){return _c('orderListItem',{key:order.orderId,attrs:{"order":order,"index":i},on:{"operation":_vm.refreshData}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }